/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon20Solid = forwardRef('ArrowUiAuthLogoutIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-4h5.042l-2.393 2.393a1 1 0 0 0 1.414 1.414l3.273-3.273a2.172 2.172 0 0 0 0-3.071L16.063 5.19a1 1 0 1 0-1.414 1.414L17.045 9H12V5a3 3 0 0 0-3-3H4Zm8 7H7a1 1 0 1 0 0 2h5V9Z" })));
});
